import React from 'react'

const Section = ({ children, shouldCoverFullHeight, isDark }) => {
  return (
    <div
      className={`w-full ${shouldCoverFullHeight ? 'min-h-screen' : ''} flex items-center justify-center ${
        isDark ? 'text-white bg-black' : ''
      }`}
    >
      <div className='py-20 w-full max-w-7xl'>{children}</div>
    </div>
  )
}

Section.defaultProps = {
  shouldCoverFullHeight: true,
}

export default Section
